export default {
  duplicated: 'DUPLICATED',
};
